module.exports = __webpack_public_path__ + "media/images/div_lens/Step3-4e75376f2dd2e018e8124d2f3e660e84.png";